import { render } from "./DeeplinkNotification.vue?vue&type=template&id=5c60d1cf&scoped=true&ts=true"
import script from "./DeeplinkNotification.vue?vue&type=script&lang=ts"
export * from "./DeeplinkNotification.vue?vue&type=script&lang=ts"

import "./DeeplinkNotification.vue?vue&type=style&index=0&id=5c60d1cf&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c60d1cf"]])

export default __exports__